<template>
  <div class="scrollable">
    <v-container class="pa-md-6 pa-3">
      <v-row>
        <v-col>
          <v-card class="mx-auto">
            <v-img :src="mediaUrl"></v-img>
            <v-card-subtitle v-if="description.length > 0" class="text-center">
              {{ description }}
            </v-card-subtitle>
            <v-card-text v-if="tags.length > 0" class="text-center">
              <span v-for="(tagId, i) in tags" :key="i">
                <v-chip v-if="tagsById[tagId]" class="mr-1" small>{{ tagsById[tagId].name }}</v-chip>
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import index from '../index';
import common from '@/mixins/common';
import { mapState } from 'vuex';

export default {
  name: 'ImageViewer',
  emits: [],
  mixins: [common],
  components: {},
  props: {
    container: {
      type: Object,
      default: () => {},
    },
    media: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('media', ['tagsById']),
    mediaProperties() {
      return this.media.properties;
    },
    mediaFileName() {
      return this.mediaProperties.filename || '';
    },
    mediaChecksum() {
      return this.mediaProperties.checksum || '';
    },
    mediaMimeType() {
      return this.mediaProperties.mimetype || '';
    },
    mediaUrl() {
      return this.moduleFileUrl(index.moduleId, this.mediaFileName, this.mediaChecksum);
    },
    properties() {
      return this.container.properties ? this.container.properties : {};
    },
    description() {
      return this.properties.description ? this.properties.description : '';
    },
    tags() {
      return this.container.tags && Array.isArray(this.container.tags) ? this.container.tags : [];
    },
  },
};
</script>
<style>
.theme-dark .article-container {
  background: #050505;
}
.theme--light .article-container {
  background: #fff;
}
.theme--dark .article {
  background: #202020;
}
.theme--light .article {
  background: #f0f0f0;
}
.scrollable {
  position: fixed;
  width: 100%;
  height: calc(100% - 64px);
  overflow-y: auto;
}
.v-card {
  box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.24) 0px 2px 16px 0px !important;
}
</style>
